import { ChangeEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutMobileCommControlPacketsTable } from "./autogen/AutogenLayoutMobileCommControlPacketsTable";

export class MobileCommControlPacketsTable extends AutogenLayoutMobileCommControlPacketsTable {

    async onLoad() {
    }

    textboxLastValueOnChange(event: ChangeEvent) {
        const textbox = event.target as Textbox;
        let lastValue = textbox?.text?.trim();

        // Limit to maximum 10 characters
        if (lastValue && lastValue.length > 10) {
            lastValue = lastValue.substring(0, 10);
            textbox.text = lastValue;
        }

        // Check if numeric value exceeds 32-bit signed integer maximum
        const numericValue = parseInt(lastValue || '0', 10);
        if (!isNaN(numericValue) && numericValue > 2147483647) {
            textbox.validationWarning = 'Value cannot exceed 2,147,483,647';
        } else {
            textbox.validationWarning = null;
        }
    }
}
